const initialIndicatorsExplanationState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  deleted: false,
  deleting: false,
  items: [],
  explanations: { fr: "", en: "", nl: "" },
  error: null
};

export const indicatorsExplanationReducer = (
  state = initialIndicatorsExplanationState,
  action
) => {
  switch (action.type) {
    case "INIT_INDICATORS_EXPLANATION": {
      return initialIndicatorsExplanationState;
    }
    case `SAVE_INDICATOR_EXPLANATION_PENDING`: {
      return {
        ...state,
        saved: false,
        saving: true
      };
    }
    case `SAVE_INDICATOR_EXPLANATION_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_INDICATOR_EXPLANATION_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }
    case "FETCH_INDICATORS_EXPLANATION_PENDING": {
      return {
        ...state,
        fetched: false,
        fetching: true
      };
    }
    case "FETCH_INDICATORS_EXPLANATION_FULFILLED": {
      const { explanation } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: explanation || []
      };
    }
    case "ADD_EXPLANATION_CONTENT": {
      return {
        ...state,
        explanations: action.explanations
      };
    }
    case "SET_EXPLANATIONS": {
      return {
        ...state,
        items: action.explanations
      };
    }
    case `DELETE_INDICATOR_EXPLANATION_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_INDICATOR_EXPLANATION_FULFILLED`: {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case `DELETE_INDICATOR_EXPLANATION_REJECTED`: {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/indicatorsExplanation.js